const getNameInitials = (name) => {
  const tempNameArray = name.split(' ');
  const nameArray = [];
  for (let i = 0; i < tempNameArray.length; i++) {
    if (tempNameArray[i]) nameArray.push(tempNameArray[i]);
  }
  if (nameArray.length === 1) return nameArray[0][0].trim().toUpperCase();
  if (nameArray.length > 1)
    return (
      nameArray[0][0].trim().toUpperCase() +
      nameArray[1][0].trim().toUpperCase()
    );
};
export default getNameInitials;
